module.exports = __webpack_public_path__ + "static/media/bhb_end.6b5a1bf8.vtt";